module.exports = __webpack_public_path__ + "static/img/1_2_2_2.e67e6f3c.jpg";